<section #sectionRef>
  <div class="chat-header" #headerRef>
    @if (!hideTitle()) {
      <h2 class="title-centre">
        Chat with <span data-dd-privacy="mask">{{ party?.name }}</span>

        @if (party) {
          <span>
            <tablesready-party-badge [party]="party" [showTypeBadge]="true"></tablesready-party-badge>
          </span>
        }
      </h2>
    }

    @if (showPartyInfo() && party) {
      <div class="party-info">
        <lib-frontend-party-info-compact
          [party]="party"
          [timezone]="timezone()"
          [editPartyMethod]="editPartyMethod"
        ></lib-frontend-party-info-compact>
      </div>
    }
  </div>

  <lib-frontend-chat
    [style.max-height.px]="sectionRef.offsetHeight - headerRef.offsetHeight - footerRef.offsetHeight"
    [style.min-height.px]="sectionRef.offsetHeight - headerRef.offsetHeight - footerRef.offsetHeight"
    [style.height.px]="sectionRef.offsetHeight - headerRef.offsetHeight - footerRef.offsetHeight"
    [messages]="messages"
    [timezone]="timezone()"
  ></lib-frontend-chat>

  <div class="chat-footer pb-3" #footerRef>
    <form [hidden]="!showReplyForm()" role="form" [formGroup]="form" novalidate>
      <div class="form-group reply-form-group">
        <div class="reply-label-row">
          <label for="sms-reply" class="control-label">Reply</label>
          <chat-counter [maxAnsiChars]="maxAnsiLength" [maxNonAnsiChars]="maxNonAnsiLength" [chats]="smsReplyControl.value"></chat-counter>
        </div>
        <textarea
          id="sms-reply"
          name="smsResp"
          type="text"
          data-dd-privacy="mask"
          [rows]="hideTitle() ? 2 : 3"
          class="w-100 border-border"
          minlength="1"
          required
          noWhitespace
          text-watcher
          bitly
          formControlName="smsReply"
          [maxlength]="maxLength"
          [ngClass]="{'is-invalid': smsReplyControl.touched && smsReplyControl.invalid}"
        ></textarea>
        <div class="reply-meta">
          <sms-warning [message]="smsReplyControl.value"></sms-warning>
          @if (smsReplyControl.touched) {
            <control-messages [control]="smsReplyControl"></control-messages>
          }
        </div>
      </div>

      <div [hidden]="!showTemplates() || !templates.length" class="row" [class.dropdown-opened]="dropDownOpened">
        <div class="col form-group">
          <frontend-dropdown
            elementId="saved-templates"
            class="w-100"
            [items]="templates"
            [multiple]="false"
            bindLabel="name"
            bindValue="id"
            placeholder="Choose saved reply"
            formControlName="replyTemplate"
            [customName]="savedReplyText"
            [customOptionHtml]="savedReplyOptionText"
            [maxListHeight]="'7rem'"
            (popoverOpen)="onDropdownTriggered(true)"
            (popoverClose)="onDropdownTriggered(false)"
          ></frontend-dropdown>
          <!-- [wrapItemText]="true" -->
        </div>
      </div>
    </form>

    <div class="d-flex flex-row align-items-center justify-content-end">
      @if (showReplyForm()) {
        <button
          type="button"
          (click)="sendSMS()"
          class="btn btn-info mr-2"
          [disabled]="form.pristine || form.invalid || !party?.phone"
          angularticsCategory="waitlist"
          angulartics2On="click"
          angularticsAction="sent SMS chat"
        >Send SMS</button>
      }
      @if (cancel) {
        <button
          type="button"
          (click)="cancel()"
          angularticsCategory="waitlist"
          angulartics2On="click"
          angularticsAction="Close Chat Modal"
          class="btn btn-danger"
        >Cancel</button>
      }
    </div>
  </div>
</section>
